import { FC, ReactNode, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDialogA11y } from "../dialog/useDialogA11y";

import "./Popup.scss";

let popupInstanceId = 0;

interface Props {
  title: string;
  isPopupOpen: boolean;
  handleClose: () => void;
  handleAction: () => void;
  cancelAction: () => void;
  leftButtonTitle: string;
  isModalDisabled?: boolean;
  children: ReactNode;
  rightButtonTitle?: string;
}

const Popup: FC<Props> = ({
  title,
  isPopupOpen,
  handleClose,
  handleAction,
  cancelAction,
  leftButtonTitle,
  isModalDisabled,
  children,
  rightButtonTitle,
}) => {
  const { t } = useTranslation();
  const dialogRef = useRef<HTMLDivElement>(null);
  const [titleId] = useState(() => {
    popupInstanceId += 1;
    return `popup-title-${popupInstanceId}`;
  });

  useDialogA11y({
    isOpen: isPopupOpen,
    onClose: handleClose,
    containerRef: dialogRef,
  });

  return (
    <div
      className={`modal ${isPopupOpen ? "fade in" : ""}`}
      data-testid="modal"
    >
      <div
        className="modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={dialogRef}
      >
        <div className="modal-content">
          <div className="modal-header">
            <button
              id="close-btn"
              type="button"
              className="close"
              aria-label={t("Close")}
              onClick={handleClose}
              data-testid="close-btn"
            />
            <h4 id={titleId} className="modal-title modal__title">
              {title}
            </h4>
          </div>
          <div className="modal-body d-flex justify-content-between align-items-center">
            {children}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            {leftButtonTitle && (
              <button
                id="submit-action"
                disabled={isModalDisabled}
                type="button"
                className="btn btn-primary modal__button"
                onClick={handleAction}
                data-testid="submit-action"
              >
                {leftButtonTitle}
              </button>
            )}
            <button
              id="cancel-action"
              disabled={isModalDisabled}
              type="button"
              className="btn btn-default modal__button"
              onClick={cancelAction}
            >
              {rightButtonTitle || t("Cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
